// Phase HUB-DRILL-1 — Main Hub full-page route.
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import RoleGate from "../../components/RoleGate";
import useTimedFetch from "../../hooks/useTimedFetch";
import MainHubDetailView, {
  HubDetailLoading, HubDetailError,
} from "../../components/founder/MainHubDetailView";

function Body() {
  const { hubId } = useParams();
  const [filters, setFilters] = useState({});
  const params = {};
  Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
  const { data, loading, error, reload } = useTimedFetch(`/founder/main-hubs/${hubId}`, { params });

  return (
    <div className="max-w-7xl mx-auto p-4 sm:p-6 space-y-3" data-testid="founder-main-hub-detail-page"
         data-hub-id={hubId}>
      <div className="flex items-center gap-2">
        <Link to="/dashboard/founder/main-hubs" className="text-[#FF6B00] hover:opacity-80"
              data-testid="main-hub-detail-back">
          <ArrowLeft className="h-5 w-5"/>
        </Link>
        <div className="text-xs text-slate-500">Main Hub</div>
        <span className="font-mono text-sm text-slate-700">{hubId}</span>
      </div>
      {loading && !data && <HubDetailLoading/>}
      {error && <HubDetailError {...error} onRetry={reload}/>}
      {data && (
        <MainHubDetailView
          data={data}
          hubId={hubId}
          reload={reload}
          filters={filters}
          onFiltersChange={setFilters}
          variant="page"
        />
      )}
    </div>
  );
}

export default function MainHubDetailPage() {
  return <RoleGate allow={["founder", "admin", "main_hub_manager", "ceo"]}><Body/></RoleGate>;
}
